import { ref, shallowRef, type Ref, type ShallowRef } from 'vue';
import { TeamCollection } from '@/modules/team/models/TeamCollection';

export const estateTaskAssignableTeams: ShallowRef<TeamCollection> = shallowRef(
  new TeamCollection()
);
export const teams: Ref<TeamCollection | undefined> = ref(undefined);
